// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2AFSd","question":"Question_question__2Wz1A","description":"Question_description__3L7_w"};